import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

import Feature from './content/Feature';
import SearchUseCases from './SearchUseCases';
import SearchExamples from './SearchExamples';

import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router";

import LastCall from "./content/LastCall";
import Newsletter from "./Newsletter";
import mixpanel from "mixpanel-browser";

import UserCondition from "./UserCondition";

import DownloadLists from "./DownloadLists";

import Plans from "./Plans";

import './content/content.css';

class SearchLearn extends Component {

	constructor() {
		super();
		this.mixpanel = mixpanel;		
	}

  render() {
    return (
      <div className="Service">
      	<Feature innerFeatureList={true} shade={false} h3="examples">
      		<SearchExamples handleSubmitWithOptionsUpdate={this.props.handleSubmitWithOptionsUpdate}></SearchExamples>
      	</Feature>

      	<Feature shade={true} h3="Export" h4="Dowload a CSV File" h5="Create a list of domains, once you have found matching websites">
      		<i className="fa fa-file-text-o fa-3x" aria-hidden="true"/>
      	</Feature>

      	<DownloadLists shade={false}/>
      	
      	<UserCondition isLoggedIn={false}>
	      	<Feature innerFeatureList={true} shade={true} h3="use cases">
	  			<SearchUseCases/>
	      	</Feature>
      	</UserCondition>
      	
      	<div className="benefit">
      		<Plans/>
      	</div>
      	
      	<UserCondition isLoggedIn={false}>      		
	      	<Feature shade={true} h3="Sign up for search" h4="Search Across Top 500,000 Websites for Free" h5="Sign up now and take advantage of unlimited search across the top half a million websites!">
	            <LinkContainer to="/signup">
	                <Button bsStyle="success" name="">
	                    Create Free Account
	                </Button>
	            </LinkContainer>
	      	</Feature>	      	
	    </UserCondition>

		<Feature h3="Consulting" h4="Your Custom Solution" h5="Are your requirements unique? Do you want to stay ahead of the competition? Contact us to discuss a solution tailored to your specific needs.">
            <Link to="/consulting">
                <Button bsStyle="default" name="">
                    Learn more
                </Button>
            </Link>

      	</Feature>      		    

	    <LastCall>
      		<Newsletter></Newsletter>
      	</LastCall>

      </div>
    );
  }
}

export default SearchLearn;



// WEBPACK FOOTER //
// ./src/SearchLearn.js